import { createSelector } from 'reselect'

import { RootState } from '@/store/Reducer'

export const selectTeamsManagement = (state: RootState) => state.teamsManagement

export const selectTeamsManagementTeams = createSelector(
  selectTeamsManagement,
  teamsManagement => teamsManagement.teams,
)

export const selectTeamsManagementCountrySites = createSelector(
  selectTeamsManagement,
  teamsManagement => teamsManagement.countrySites ?? [],
)

export const selectTeamsManagementIsLoading = createSelector(
  selectTeamsManagement,
  teamsManagement => teamsManagement.isLoadingTeams,
)

export const selectTeamsManagementSelectedTeam = createSelector(
  selectTeamsManagement,
  teamsManagement => teamsManagement.selectedTeam,
)

export const selectTeamsManagementTeamsError = createSelector(
  selectTeamsManagement,
  teamsManagement => teamsManagement.teamsError,
)
